import React from 'react';
import MiCompAPI from '../../../util/api';
import { Form, Input, Button, Row, Col, Select ,Icon} from 'antd';
// import img from '../../../assets/img/Illustration.png';
const { Option } = Select;
class InviteForm extends React.Component {
    constructor(props) {
        
        super(props)
        this.state = {
            sqs: [],
            sqsoriginal: [],
            selectedqs: [],
            selectedqs1: null,
            selectedqs2: null,
            selectedqs3: null,

        }
        this.api = new MiCompAPI(null);
    }
    handleSubmit = (e) => {

        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.submitHandler({ ...values, invitation_Id: this.props.data.id });
            }
        });
    }
    Cancel() {
        sessionStorage.clear();
        window.location.pathname = "";
    }
    componentDidMount = () => {
        this.getAllSQs();
    }

    qsChange = (type, e) => {

        if (type === '1') {
            this.setState({
                selectedqs1:e
            })
        }
        if (type === '2') {
            this.setState({
                selectedqs2:e
            })
        }
        if (type === '3') {
            this.setState({
                selectedqs3:e
            })
        }

        setTimeout(() => {
            this.setState({
                selectedqs: [this.state.selectedqs1, this.state.selectedqs2,this.state.selectedqs3]
            })
            this.setState({
                sqs: this.state.sqsoriginal.filter(x => !this.state.selectedqs.includes(x.id))
            })
        }, 100);
    }
    getAllSQs() {
        this.api.invoke("GetsecurityQuestions", "get", (data, success) => {
            if (success) {
                this.setState({
                    sqs: data.data,
                    sqsoriginal: data.data
                })
            }
        });
    }
    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        return (
            <Form onSubmit={this.handleSubmit} layout="vertical" autoComplete="none" hideRequiredMark >
                {this.props.type==="members"&&
                
                <Row span={24}>
                    <Col span={12}>
                    <Form.Item>
                                <fieldset className="mi_fieldset1 mi_input_pop">
                                    <legend className="legend-font">Email Id</legend>
                                    {getFieldDecorator('email', {
                                        rules: [{
                                            type: 'email', message: 'Please enter valid Email..',
                                        }, { required: true, message: 'Please enter  email id.' },
                                        { whitespace: true, message: "Email is invalid." },
                                        {
                                            pattern: /^([a-zA-Z0-9\s.]+)@([a-zA-Z0-9]+)\.([a-zA-Z]{2,5})$/,
                                            message: 'Email is invalid.'
                                        }],
                                    })(<Input type="email" autoComplete={"nope"} className="mi_input" placeholder="Enter Email Id *" />)}
                                </fieldset>
                            </Form.Item>
                    </Col></Row>}
                <Row span={24}>
                    <Col span={12}>
                        <Form.Item>
                            <fieldset className="mi_fieldset1 mi_input_pop">
                                <legend className="legend-font">Password</legend>
                                {getFieldDecorator('pass', {
                                    rules: [{ required: true, message: 'Please enter a password' },
                                    {
                                        pattern: /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/,
                                        message: "Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character!"
                                    }],
                                })(<Input.Password type="password" id="password" autoComplete={"nope"}  className="mi_input"  placeholder="Enter Password *"/>)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item dependencies={['pass']}>
                            <fieldset className="mi_fieldset1 mi_input_pop">
                                <legend className="legend-font">Confirm Password</legend>
                                {getFieldDecorator('password', {
                                    rules: [{ required: true, message: 'Please confirm your password!' },
                                    {
                                        validator(rule, value) {
                                            if (!value || getFieldValue('pass') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('passwords that you entered do not match!');
                                        }
                                    }
                                    ],
                                })(<Input.Password type="password" id="password" autoComplete={"nope"}  className="mi_input"  placeholder="Enter Confirm Password *" />)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                </Row>
                <Row span={24}>
                    <Col span={12}>
                        <Form.Item dependencies={['sQ2', 'sQ3']}>
                            <fieldset className="mi_fieldset1 mi_input_pop">
                                <legend className="legend-font">Security Question1</legend>
                                {getFieldDecorator('sQ1', {
                                    rules: [{ required: true, message: 'Please select Security Question' },
                                    {
                                        validator(rule, value) {
                                            if (!value || (getFieldValue('sQ2') !== value && getFieldValue('sQ3') !== value)) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('Questions should not be repeated!');
                                        }
                                    }],
                                })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="ant-input mi_input"
                                    optionFilterProp="children"
                                    showSearch={true}
                                    onChange={this.qsChange.bind(this, '1')}
                                    filterOption={(input, option) =>
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    }
                                    placeholder="Security Question1 *"  >
                                    {this.state.sqs ? this.state.sqs.map(tag => <Option value={tag.id} key={tag.id}>{tag.securit_Question}</Option>) : ""}
                                </Select>)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item dependencies={['answer2', 'answer3']}>
                            <fieldset className="mi_fieldset1 mi_input_pop">
                                <legend className="legend-font">Answer</legend>
                                {getFieldDecorator('answer1', {
                                    rules: [{ required: true, message: 'Please enter Answer' },
                                    {
                                        pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s]+$/,
                                        message: '"It allows only Alphanumerics,No whitespace at the beginning and end"'
                                    },
                                    {
                                        validator(rule, value) {
                                            if (!value || (getFieldValue('answer2') !== value && getFieldValue('answer3') !== value)) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('Answers should not match!');
                                        }
                                    }],
                                })(<Input type="text" autoComplete={"nope"}  className="mi_input"  placeholder="Enter Answer *" />)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                </Row>
                <Row span={24}>
                    <Col span={12}>
                        <Form.Item dependencies={['sQ1', 'sQ3']}>
                            <fieldset className="mi_fieldset1 mi_input_pop">
                                <legend className="legend-font">Security Question2</legend>
                                {getFieldDecorator('sQ2', {
                                    rules: [{ required: true, message: 'Please select Security Question' },
                                    {
                                        validator(rule, value) {
                                            if (!value || (getFieldValue('sQ1') !== value && getFieldValue('sQ3') !== value)) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('Questions should not be repeated!');
                                        }
                                    }],
                                })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="ant-input mi_input"
                                    optionFilterProp="children"
                                    showSearch={true}
                                    onChange={this.qsChange.bind(this, '2')}

                                    filterOption={(input, option) =>
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    }
                                    placeholder="Security Question2 *" >
                                    {this.state.sqs ? this.state.sqs.map(tag => <Option value={tag.id} key={tag.id}>{tag.securit_Question}</Option>) : ""}
                                </Select>)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                    <Col span={12} dependencies={['answer1', 'answer3']}>
                        <Form.Item>
                            <fieldset className="mi_fieldset1 mi_input_pop">
                                <legend className="legend-font">Answer</legend>
                                {getFieldDecorator('answer2', {
                                    rules: [{ required: true, message: 'Please enter Answer' },
                                    {
                                        pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s]+$/,
                                        message: '"It allows only Alphanumerics,No whitespace at the beginning and end"'
                                    },
                                    {
                                        validator(rule, value) {
                                            if (!value || (getFieldValue('answer1') !== value && getFieldValue('answer3') !== value)) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('Answers should not match!');
                                        }
                                    }],
                                })(<Input type="text" autoComplete={"nope"}  className="mi_input" placeholder="Enter Answer *" />)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                </Row> <Row span={24}>
                    <Col span={12}>
                        <Form.Item dependencies={['sQ1', 'sQ2']}>
                            <fieldset className="mi_fieldset1 mi_input_pop">
                                <legend className="legend-font">Security Question3</legend>
                                {getFieldDecorator('sQ3', {
                                    rules: [{ required: true, message: 'Please select Security Question' },
                                    {
                                        validator(rule, value) {
                                            if (!value || (getFieldValue('sQ1') !== value && getFieldValue('sQ2') !== value)) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('Questions should not be repeated!');
                                        }
                                    }],
                                })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className=" ant-input mi_input"
                                    optionFilterProp="children"
                                    showSearch={true}
                                    onChange={this.qsChange.bind(this, '3')}

                                    filterOption={(input, option) =>
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    }
                                    placeholder="Security Question3 *" >
                                    {this.state.sqs ? this.state.sqs.map(tag => <Option value={tag.id} key={tag.id}>{tag.securit_Question}</Option>) : ""}
                                </Select>)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item dependencies={['answer1', 'answer2']}>
                            <fieldset className="mi_fieldset1 mi_input_pop">
                                <legend className="legend-font">Answer</legend>
                                {getFieldDecorator('answer3', {
                                    rules: [{ required: true, message: 'Please enter Answer' },
                                    {
                                        pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s]+$/,
                                        message: '"It allows only Alphanumerics,No whitespace at the beginning and end"'
                                    },
                                    {
                                        validator(rule, value) {
                                            if (!value || (getFieldValue('answer1') !== value && getFieldValue('answer2') !== value)) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('Answers should not match!');
                                        }
                                    }
                                    ],
                                })(<Input type="text" autoComplete={"nope"}  className="mi_input"   placeholder="Enter Answer *" />)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                </Row>
                <Row span={24} className="ant-row1">


                    <Button className="submit-button" htmlType="submit" type="primary" >
                        Register
                    </Button>

                    <Button className="submit-button" onClick={() => this.Cancel()}>
                        Cancel
                    </Button>




                </Row>
            </Form>
        );
    }
}
export default InviteForm